<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-16 16:31:17
 * @LastEditTime: 2021-03-04 15:38:53
-->
<template>
  <div class="history-data">
    <!-- <div class="line-chart"> -->
    <!-- <line-chart :autoresize="true" :options="lineOptions"></line-chart> -->
    <el-table size="mini" id="out-table" :data="historyData" row-key="id" :header-cell-style="{ background: '#e4f1ff' }"
      height="400" style="min-width:860px;">
      <el-table-column :label="$t('lang.alarmNotice.serialNumber')" type="index" width="108">
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.variable')">
        <template slot-scope="scope">
          <span class="font-style">{{ scope.row.vname }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" :label="$t('lang.alarmNotice.numberValue')">
        <template slot-scope="scope">
          <span class="font-style">{{ scope.row.strVal }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.variableList.unit')">
        <template slot-scope="scope">
          <span class="font-style">{{ unitObj[scope.row.unit] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.particulars.UpgradeTime')">
        <template slot-scope="scope">
          <span class="font-style">{{ scope.row.ts | formateTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="historyTotal" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import { PublicComponent } from "@/mixins/common";
import moment from "moment";
import { unitObj } from "@/utils/paramsConfig";
import { getHistoryData,getHistoryDataAll } from "@/api/cloudMonitor/historyData";
export default {
  mixins: [PublicComponent],
  props: ["searchData", "deviceItem"],
  data() {
    return {
      unitObj,
      historyData: [],
      historyTotal: 0,
    };
  },
  components: {
    pagination,
  },
  filters: {
    formateTime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  mounted() { },
  methods: {
    // 清空数据
    clearData() {
      this.historyData = [];
      this.historyTotal = 0;
    },
    queryKeyword() {
      if (this.searchData.dtuid && this.searchData.vid) {
        let params = {
          current: this.offset,
          size: this.limit,
          dtuid: this.searchData.dtuid,
          did: this.deviceItem.deviceDid,
          vid: this.searchData.vid,
          sts: moment(this.searchData.time[0]).format("YYYY-MM-DD HH:mm:ss"),
          ets: moment(this.searchData.time[1]).format("YYYY-MM-DD HH:mm:ss"),
        };
        getHistoryData(params).then((res) => {
          console.log(res);
          if (res.data.code === 0) {
            this.historyData = res.data.data.records;
            this.historyTotal = res.data.data.total;
          }
        });
      }
    },
    exportData() {
      return new Promise((resolve, reject) => {
        if (this.searchData.dtuid && this.searchData.vid) {
          let params = {
            dtuid: this.searchData.dtuid,
            did: this.deviceItem.deviceDid,
            vid: this.searchData.vid,
            sts: moment(this.searchData.time[0]).format("YYYY-MM-DD HH:mm:ss"),
            ets: moment(this.searchData.time[1]).format("YYYY-MM-DD HH:mm:ss"),
          };
          getHistoryDataAll(params).then((res) => {
            if (res.data.code === 0) {
              this.historyData = res.data.data;
              resolve()
            }
            reject()
          });
        } else {
          this.$message({
            message: "请选择设备",
            type: "warning",
          });
          reject()
        }
      });
    }
  },
  watch: {
    "searchData.dtuid": {
      handler(newV) {
        if (newV) {
          this.clearData()
          this.queryKeyword();
        }
      },
      deep: true,
    },
    "searchData.vid": {
      handler(newV) {
        if (newV) {
          this.clearData()
          this.queryKeyword();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.con {
  text-align: center;
  margin-top: 0.4rem;
}

.font-style {
  font-size: 0.25rem;
}
</style>
